import React, { useEffect } from 'react';
import SplashModal from './SplashModal';
import TopoBackground from './TopoBackground';
import { useTextReveal } from '../hooks/useTextReveal';

// /book — the direct-booking request as its own page, styled like the homepage
// hero: contour background, Gloock title, arch photo. The form on the right
// runs in three short steps (dates → Airbnb price → your details).
// It's reached only from the one-time "15% off your next stay" email; the guide
// never links here (Airbnb off-platform policy), and search engines are asked
// not to index it.
const BookPage: React.FC = () => {
  useTextReveal();
  useEffect(() => {
    document.title = 'Book your next stay · Corazón Townhouse';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    document.head.appendChild(robots);
    return () => robots.remove();
  }, []);

  return (
    <div className="book-page">
      <TopoBackground lineColor="62,67,120" />
      <main className="book-layout">
        <section className="book-hero" aria-labelledby="book-hero-title">
          <p className="book-hero-eyebrow">Your next stay</p>
          <h1 id="book-hero-title" className="book-hero-title">
            Come back <br className="book-hero-break" />
            to <em>Corazón</em>
          </h1>
          <p className="book-hero-lede">
            Three quick steps. We&rsquo;ll reply with your direct rate — 15% under Airbnb, usually within a day.
          </p>
          <p className="book-hero-note">
            For future stays only — your current reservation stays on Airbnb.
          </p>
          <figure className="book-hero-arch">
            <img src="images/kerry-sunrise.webp" alt="Seattle's skyline at sunrise from Kerry Park" width={440} height={520} />
          </figure>
        </section>

        <div className="book-form">
          <SplashModal isOpen variant="page" onClose={() => window.location.assign('/')} />
        </div>
      </main>
    </div>
  );
};

export default BookPage;
